export function findActiveElement() {
  const getActiveElementDeep = activeElement => {
    if (activeElement && activeElement.shadowRoot) {
      return activeElement.shadowRoot.activeElement;
    }

    return activeElement;
  };

  let lastActiveElement = null;
  let nextActiveElement = document.activeElement;

  if (!nextActiveElement) {
    return null;
  }

  while (lastActiveElement !== nextActiveElement) {
    lastActiveElement = nextActiveElement;
    nextActiveElement = getActiveElementDeep(lastActiveElement);
  }

  return nextActiveElement;
}
